// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__A4ZoK","modalFooterButton":"ModalNotes_modalFooterButton__2p0cK"};